/* IMPORT */
import { OWNER } from '../objects/superroot.js';
import { lazyArrayPush } from '../lazy.js';
/* MAIN */
const cleanup = (fn) => {
    lazyArrayPush(OWNER, 'cleanups', fn);
};
/* EXPORT */
export default cleanup;
